import { openPosCheckout } from 'utilities/open-pos-checkout';

import { dispatchLegacyEvent } from './legacyEventDispatcher';
import { getCurrentEmployeeName } from './getCurrentEmployeeName';
import { getIsNativeApp } from './getIsNativeApp';
import { getReconnectLocale } from './getReconnectLocale';

// Built at inject time, not cached: App.config is refetched and mutated in place
// (go-live, settings saves) without a dedicated event. `trackingService` is
// per island, so the caller merges it in (see Reconnect.tsx).
export const buildPageConfig = (): Omit<Config, 'trackingService'> => {
  const venue = App.config.get('venue');
  const account = App.config.get('account');

  return {
    appointmentNoteCharacterLimit: 2000,
    clientNoteCharacterLimit: 2000,
    countryCode: venue.countryCode,
    venueId: venue.id,
    supplierId: App.getSupplierId(),
    clientId: -1,
    commissionAbuser: venue.commissionAbuser,
    isMasquerade: account.masquerade,
    isVatFeatureEnabled: App.config.isVatPayerFeatureEnabled(),
    isIdentityVerificationNeeded: App.isIdentityVerificationNeeded(),
    isBankAccountSyncNeeded: App.isBankAccountSyncNeeded(),
    isPointOfSaleEnabled: venue.pointOfSaleEnabled,
    isProd: App.isProd,
    entryPoint: 'reconnect',
    isNativeApp: getIsNativeApp(),
    locale: getReconnectLocale(),
    venueLocale: venue.locale || App.domainLocale,
    channelSupportedLocales: App.config.getChannelSupportedLocales() || {
      English: 'en',
    },
    currencyCode: Wahanda.Currency.getCurrencyCode(),
    numberFormat: App.config.getNumberFormat(),
    isListedOnMarketplace: venue.listedOnMarketplace,
    isVenueLive: App.config.isVenueActive(),
    permitAppointmentReschedule: venue.permitAppointmentReschedule,
    consumerEmailNotifications: venue.consumerEmailNotifications,
    aboutGDPRLink: 'https://partnercare.treatwell.com/s/article/Introduction-to-GDPR',
    dispatchLegacyEvent,
    openPosCheckout,
    isDisplayClientPrepayEnabled:
      !!venue.supportsMultiplePaymentOptions && App.isFeatureSupported('prepayment-required'),
    currentEmployeeId: account.employeeId,
    currentEmployeeName: getCurrentEmployeeName(),
    accountId: account.id,
    appointmentSlotDuration: venue.appointmentSlotDuration,
    venueDayStartsAt: venue.dayStartsAt,
    venueDayEndsAt: venue.dayEndsAt,
    blockNameCharacterLimit: 128,
    isAdministrator: App.isAdministrator(),
    venueName: venue.name,
    venueTimeZone: venue.zoneId,
  };
};
